import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {DataItem} from '@app/components/shared/model/data-item';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {KombinationstypEnum} from '@app/constants/kombinationstyp';
import {FenceResultSelectedEvent} from '@app/components/fense-result/fense-result-button/fence-result-selected-event';
import {ChipListComponent} from '@app/components/shared/chip-list/chip-list.component';
import {ResultCodeFacadeService} from '@app/facade-services/result-code/result-code-facade.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { MatButton } from '@angular/material/button';
import { RepportFenceEvent } from '@app/components/fense-result/fense-result-button/repport-fence-event';
import { ResultCode } from '@app/rest-client/faxe/models';


@Component({
  selector: 'faxe-fense-result-button',
  templateUrl: './fense-result-button.component.html',
  styleUrls: ['./fense-result-button.component.scss'],
  imports: [
    ChipListComponent,
    MatButton
  ]
})
export class FenseResultButtonComponent implements OnInit, OnDestroy {
  @ViewChild('resultCodes') chipListComponent: ChipListComponent<DataItem<ResultCode>>;
  @Input() header: string;
  @Input() fenceName: string;
  @Output() selected: EventEmitter<FenceResultSelectedEvent<ResultCode>> = new EventEmitter<FenceResultSelectedEvent<ResultCode>>();
  @Output() unSelected: EventEmitter<FenceResultSelectedEvent<ResultCode>> = new EventEmitter<FenceResultSelectedEvent<ResultCode>>();
  @Output() lastUnSelected: EventEmitter<FenceResultSelectedEvent<ResultCode>> = new EventEmitter<FenceResultSelectedEvent<ResultCode>>();
  @Output() repportFence: EventEmitter<RepportFenceEvent> = new EventEmitter<RepportFenceEvent>();
  formGroup: UntypedFormGroup = this.formBuilder.group({});
  resultCodesDataItem: DataItem<ResultCode>[];
  preselectedKey: string[];
  resultCodeGuid:  string[];
  anyResultCodeSelected: boolean;
  reported = false;
  private unsubscribe$ = new Subject<void>();

  constructor(private readonly formBuilder: UntypedFormBuilder,
              private readonly resultCodeFacadeService: ResultCodeFacadeService) {
  }

  @Input() set preSelectedKeys(resultCodeGuid: string[]) {
    this.resultCodeGuid = resultCodeGuid;
  }

  ngOnInit(): void {
    this.anyResultCodeSelected = false
    this.getResultCodes();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  clear(): void {
    this.chipListComponent?.clear();
  }

  getResultCodes(): void {
    this.resultCodeFacadeService
      .fetchAllResultCodes('FenseResultButtonComponent')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(resultCodes => {
          this.setData(resultCodes);
        }
      );
  }

  setData(resultCodes: ResultCode[]): void {
    if (resultCodes) {
      this.resultCodesDataItem = resultCodes.map(code => this.mapResultCodes(code));
    }
  }

  mapResultCodes(resultCode: ResultCode): DataItem<ResultCode> {
    return ({
      key: resultCode.resultCodeGuid,
      value: resultCode,
      displayname: resultCode.name,
      kombinationstypEnum: this.mapCombination(resultCode.isCombinable),
      sortOrder: 0,
      fault: resultCode.isFault
    });
  }

  mapCombination(combinable: boolean): KombinationstypEnum {
    return combinable ? KombinationstypEnum.canNExcludeOthers : KombinationstypEnum.can1AndExcludeOthers;
  }

  resultSelected($event: DataItem<ResultCode>) {
    this.anyResultCodeSelected = true;
    this.selected.emit({
      key: this.fenceName,
      value: $event.value
    });
  }

  onLastUnSelected($event: DataItem<ResultCode>) {
    this.anyResultCodeSelected = false;
    this.lastUnSelected.emit({
      key: this.fenceName,
      value: $event
    });
  }

  onUnSeleted($event: DataItem<ResultCode>) {
    this.unSelected.emit({
      key: this.fenceName,
      value: $event.value
    });
    this.reported = false;
  }

  onResultPreSelected($event: DataItem<ResultCode>[]) {
    $event.forEach(e => this.selected.emit({
      key: this.fenceName,
      value: e.value
    }));
  }

  onReportClick() {
    this.repportFence.emit({
      fenceName: this.fenceName,
      resultCodes: this.formGroup.value.resultCodes.value.map(item => item.value)
    })
    this.reported = true;
  }

}
